export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export function Switch({ checked, onChange, disabled, label }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`jaiho-switch${checked ? " jaiho-switch--on" : ""}`}
      onClick={() => onChange(!checked)}
    >
      <span className="jaiho-switch__thumb" />
    </button>
  );
}
